/**
 * Group items into ordered buckets. Insertion order of first appearance
 * is preserved. Empty-string keys are passed through untouched — callers
 * decide their own key fallbacks.
 */
export const groupBy = <T, K extends string>(
  items: T[],
  keyOf: (item: T) => K,
): Array<{ key: K; items: T[] }> => {
  const buckets = new Map<K, T[]>();
  for (const item of items) {
    const key = keyOf(item);
    const bucket = buckets.get(key);
    if (bucket) {
      bucket.push(item);
    } else {
      buckets.set(key, [item]);
    }
  }
  return Array.from(buckets, ([key, grouped]) => ({ key, items: grouped }));
};
